export enum DialogType {
  AddCard,
  Alternative,
  CarRentalAlternatives,
  Confirmation,
  ExperienceAlternatives,
  ExperienceDetails,
  ExperienceVoucher,
  FlightAlternatives,
  GenericTransportationAlternatives,
  PaymentDetails,
  RequestTrip,
  ScheduleCall,
  StoryDetails,
  TopLevelTrip,
  TransferAlternatives,
  Travelers,
}
